import React, { useState, useEffect } from 'react';
import CardDesign from './cardsDesign';
import Carousel from './carousel';

const CourseCarousel = ({courses}) => {

    return (
        <Carousel spaceBetween={2} hideArrowsMobile={true} useTimer={true} elementsPerPage={3} elements={courses.map((card, index) => (
            <CardDesign key={card.id} id={card.id} name={card.title} image={card.image_url} author={card.instructor_name} pic={card.instructor_image_url} price={card.price} duration={card.duration} capacity={card.capacity} enrolled_students_count={card.enrolled_students_count}/>
        ))} />
    );
};

export default CourseCarousel